export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_SERVICE = 'store-locator';
